/*
 * @Author: li
 * @Date: 2017-11-30 14:05:50
 * @Last Modified by: li
 * @Last Modified time: 2017-12-07 13:56:42
 */
class Native {
  constructor() {
    this.platform = this.getPlatform()
    window['JSInterface'] = {}
  }
  getPlatform() {
    let userAgent = (window && 'navigator' in window && 'userAgent' in navigator && navigator.userAgent.toLowerCase()) || ''
    // eslint-disable-next-line one-var
    const iPad = userAgent.match(/ipad/), // null or ['mac os x', index: 30, input: 'xx']
      // some wp platform fake userAgent to android
      Android = userAgent.match(/android/) && !userAgent.match(/windows phone/),
      iOS = userAgent.match(/iphone/),
      WinPhone = userAgent.match(/windows phone/),
      Mac = userAgent.match(/mac os x/),
      Windows = userAgent.match(/window/),
      Linux = userAgent.match(/linux/),
      Blackberry = userAgent.match(/blackberry/),
      Tablet = /ipad|android(?!.*mobile)/i.test(userAgent),
      AndroidTablet = /android/.test(userAgent) && !/mobile/.test(userAgent)
    const device = [
      iPad, Android, iOS, WinPhone, Mac, Windows, Linux, Blackberry, Tablet, AndroidTablet
    ]
    const arrDevice = [
      'iPad', 'android', 'ios', 'windowsPhone', 'mac', 'windows',
      'linux', 'blackBerry', 'tablet', 'androidTablet'
    ]
    for (let k = 0; k < device.length; k++) {
      if (device[k]) {
        return arrDevice[k]
      }
    }
    return 'unknow'
  }
  isiOS() {
    return this.platform === 'ios'
  }
  isAndroid() {
    return this.platform === 'android'
  }
  connectWebViewJavascriptBridge(callback) { // 桥接
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge)
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback)
    }
    window.WVJBCallbacks = [callback]
    var WVJBIframe = document.createElement('iframe')
    WVJBIframe.style.display = 'none'
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
    document.documentElement.appendChild(WVJBIframe)
    setTimeout(function () {
      document.documentElement.removeChild(WVJBIframe)
    }, 0)
  }
  on(type, func) {
    if (this.platform === 'android') {
      window['JSInterface'][type] = func
    } else if (['ios', 'iPad'].includes(this.platform)) {
      this.connectWebViewJavascriptBridge((bridge) => {
        bridge.registerHandler(type, func)
      })
    }
  }
  emit(type, params, callback) {
    try {
      if (typeof params === 'function') {
        callback = params
        params = undefined
      }
      if (this.platform === 'android') {
        let res
        if (typeof params === 'object' && JSON.stringify(params) === '{}') {
          params = undefined
        }
        if (!params) {
          res = window.android[type]()
        } else if (typeof params === 'string') {
          res = window.android[type](params)
        } else if (typeof params === 'object') {
          res = window.android[type](JSON.stringify(params))
        }
        callback && callback(typeof res === 'string' ? (res.startsWith('{') ? JSON.parse(res) : res) : res)
      } else if (['ios', 'iPad'].includes(this.platform)) {
        this.connectWebViewJavascriptBridge((bridge) => {
          bridge.callHandler(type, params, (response) => {
            callback && callback(response)
          })
        })
      }
    } catch (e) {
      console.warn(e)
    }
  }
}
export default new Native()
